export const BRAND = {
  name: "VG Homes",
  tagline: "Crafting High-Yield & Bespoke Living Spaces",
  phone: "+91 9500500123",
  whatsapp: "https://wa.me/919500500123?text=Hello%20VG%20Homes,%20I%20would%20like%20to%20inquire%20about%20your%20projects.",
  email: "contact@vghomes.in",
  address: "Chennai, Tamil Nadu, India",
};
